import i18n from '@/helper/i18n';

export default function formatDebtorStatus(value) {
  return i18n.te(`debtors.statusOptions.${value}`)
    ? i18n.t(`debtors.statusOptions.${value}`)
    : value;
}
